import { type ProductDeliveryData } from '@/fo/feature/product/info/main';
import { type StorePoint } from '@/fo/feature/shops/page/base';
import { UiKitModalBase } from '@/fo/ui/kit/modal/base';

import { ShippingInfo } from '../components/ShippingInfo/ShippingInfo';

import { styles } from './UiProductInfoShipping.styles';

interface ProductInfoShippingProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelectCity?: (city: string) => void;
  storesData?: {
    stores: StorePoint[];
    error?: string | null;
    productDeliveryData: ProductDeliveryData | null;
  };
  isLoading?: boolean;
}

export function UiProductInfoShipping({
  open,
  onOpenChange,
  storesData,
  onSelectCity,
  isLoading
}: ProductInfoShippingProps) {
  const slots = styles();

  return (
    <UiKitModalBase
      title=""
      className={slots.base()}
      isOpen={open}
      setIsOpen={onOpenChange}
    >
      <ShippingInfo
        onSelectCity={onSelectCity}
        data={storesData}
        isLoading={isLoading ?? false}
      />
    </UiKitModalBase>
  );
}
